export default __webpack_public_path__ + "static/media/playlist-Background.d37fa60d.jpg";